import { PlusOutlined } from "@ant-design/icons";
import React from "react";

const PromotionalCard = ({
  icon,
  title,
  description,
  isActive,
  setSelectedPromo,
  setActivePromoVariant,
}) => {
  const handleSelectPromo = (title) => {
    setSelectedPromo(title);
    setActivePromoVariant(title);
  };
  return (
    <article
      className={` ${
        isActive ? "promotionalCard promotionalCard-active" : "promotionalCard"
      }`}
    >
      <header className="cardHeader">
        <img src={icon} className="cardIcon" alt="" />
        <button
          className="iconButton"
          onClick={() => handleSelectPromo(title)}
          type="button"
          aria-label="Action button"
        >
          <PlusOutlined className="actionIcon" />
        </button>
      </header>
      <div className="cardContent">
        <h2 className="cardTitle">{title}</h2>
        <p className="cardDescription">{description}</p>
      </div>
    </article>
  );
};

export default PromotionalCard;
